import { Link } from "react-router-dom";
import { Phone, Mail, ShieldCheck, HeartPulse } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/data/content";

const groups = [
  {
    title: "Devices",
    links: [
      { label: "Home Guardian", to: "/shop" },
      { label: "GoMobile GPS", to: "/shop" },
      { label: "FallGuard Pro", to: "/shop" },
      { label: "LifeWatch Smart", to: "/shop" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", to: "/about" },
      { label: "How It Works", to: "/how-it-works" },
      { label: "Pricing", to: "/pricing" },
      { label: "Reviews", to: "/reviews" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "FAQ", to: "/faq" },
      { label: "Contact", to: "/contact" },
      { label: "Get a Quote", to: "/contact" },
      { label: "Cart", to: "/cart" },
      { label: "Admin", to: "/admin" },
    ],
  },
];

export const Footer = () => (
  <footer className="relative bg-brand-navy text-white" data-testid="site-footer">
    <div className="absolute inset-0 bg-dotgrid opacity-60" />
    <div className="relative container-x pt-16 pb-10">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Link to="/" className="inline-flex items-center gap-2.5" data-testid="footer-logo">
            <span className="grid place-items-center w-11 h-11 rounded-xl bg-white/10">
              <HeartPulse className="w-6 h-6 text-brand-red" strokeWidth={2.6} />
            </span>
            <span className="font-display font-extrabold text-2xl leading-none">
              <span className="text-white">Life</span>
              <span className="text-brand-red">Button</span>
              <span className="text-white/70">.org</span>
            </span>
          </Link>
          <p className="mt-2 font-display font-bold text-brand-red tracking-wide">
            {BRAND.tagline}
          </p>
          <p className="mt-5 text-white/70 leading-relaxed max-w-sm">
            Life-saving medical alert systems with 24/7 US-based monitoring. Fast response,
            compassionate care, always there.
          </p>
          <div className="mt-6 flex flex-col gap-3">
            <a
              href={BRAND.phoneHref}
              data-testid="footer-phone"
              className="inline-flex items-center gap-3 font-bold text-lg hover:text-brand-red transition-colors"
            >
              <span className="grid place-items-center w-10 h-10 rounded-full bg-brand-red">
                <Phone className="w-4 h-4" strokeWidth={2.6} />
              </span>
              {BRAND.phone}
            </a>
            <a
              href={`mailto:${BRAND.email}`}
              className="inline-flex items-center gap-3 text-white/70 hover:text-white transition-colors"
            >
              <span className="grid place-items-center w-10 h-10 rounded-full bg-white/10">
                <Mail className="w-4 h-4" />
              </span>
              {BRAND.email}
            </a>
          </div>
        </div>

        {groups.map((g) => (
          <div key={g.title}>
            <h4 className="font-display font-bold text-sm uppercase tracking-[0.18em] text-white/50">
              {g.title}
            </h4>
            <ul className="mt-5 space-y-3">
              {g.links.map((l, i) => (
                <li key={i}>
                  <Link
                    to={l.to}
                    className="text-white/80 hover:text-brand-red transition-colors font-medium"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-wrap items-center gap-4 text-sm text-white/50">
        <span className="inline-flex items-center gap-2 text-white/70">
          <ShieldCheck className="w-4 h-4 text-brand-red" /> UL-Listed · TMA Five Diamond Certified
        </span>
        <span className="hidden sm:inline">·</span>
        <span>© {new Date().getFullYear()} LifeButton.org. All rights reserved.</span>
      </div>
      <p className="mt-5 text-xs leading-relaxed text-white/40 max-w-4xl">
        Medical alert devices do not prevent falls or guarantee a specific outcome. Response times
        vary based on cellular coverage, device condition, and emergency-services availability.
        Testimonials are composite customer stories with names and identifying details changed for
        privacy. In a life-threatening emergency, always call 911.
      </p>
    </div>
  </footer>
);
